import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import styled from "styled-components";
// import { Link } from "react-router-dom";
import { Flex, Box, Text } from "rebass";
import Paper from "material-ui/Paper";
// import TextField from "material-ui/TextField";
import { cyan500 } from "material-ui/styles/colors";

class ActivationDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.record
    };
  }
  checkGender(gender) {
    if (gender && gender === "m") {
      return "Male";
    } else if (gender && gender === "f") {
      return "Female";
    }
    return "";
  }
  render() {
    const { data } = this.state;
    //console.log(this.props);
    // console.log(data);
    return (
      <Box w={[1]} p={[2]}>
        <Paper zDepth={1} rounded={false}>
          <Flex w={[1]} p={[2]}>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Order Ref
              </Text>
              <a
                href={`/#/orders/${data.order_id}`}
                target="_blank"
                style={{ textDecorationColor: cyan500 }}
              >
                <LinkText>{data.ref}</LinkText>
              </a>
            </Box>
          </Flex>
          <Flex w={[1]} p={[2]} direction={["row"]} justify={["flex-start"]}>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Date
              </Text>
              <Text>{moment(data.created_at).format("DD-MM-YYYY")}</Text>
            </Box>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Status
              </Text>
              <Text>{data.status}</Text>
            </Box>
          </Flex>
          <Flex w={[1]} p={[2]} direction={["row"]} justify={["flex-start"]}>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Name
              </Text>
              <Text>
                {data.first_name} {data.last_name}
              </Text>
            </Box>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Gender
              </Text>
              <Text>{this.checkGender(data.gender)}</Text>
            </Box>
          </Flex>
          <Flex
            w={[1]}
            p={[2]}
            direction={["column", "row"]}
            justify={["flex-start"]}
          >
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Email
              </Text>
              <Text>{data.email}</Text>
            </Box>
            <Box w={[1]} pt={[2, 0]}>
              <Text py={[1]} f={["12px"]}>
                Mother's name
              </Text>
              <Text>{data.mother_name}</Text>
            </Box>
          </Flex>
          <Flex w={[1]} p={[2]}>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                Address
              </Text>
              <Text>{data.address}</Text>
            </Box>
          </Flex>
        </Paper>
        <Box w={[1]} py={[2]}>
          <Paper zDepth={1} rounded={false}>
            <Flex w={[1]} p={[2]} direction={["row"]} justify={["flex-start"]}>
              <Box w={[1]}>
                <Text py={[1]} f={["12px"]}>
                  MSISDN
                </Text>
                <Text>{data.msisdn}</Text>
              </Box>
              <Box w={[1]}>
                <Text py={[1]} f={["12px"]}>
                  SIM #
                </Text>
                <Text>{data.sim_card_number}</Text>
              </Box>
            </Flex>
            <Flex w={[1]} p={[2]} direction={["row"]} justify={["flex-start"]}>
              <Box w={[1]}>
                <Text py={[1]} f={["12px"]}>
                  Plan Type
                </Text>
                <Text>{data.plan_type}</Text>
              </Box>
              <Box w={[1]}>
                <Text py={[1]} f={["12px"]}>
                  Plan ID
                </Text>
                <Text>{data.plan_id}</Text>
              </Box>
            </Flex>
            <Flex w={[1]} p={[2]}>
              <Box w={[1]}>
                <Text py={[1]} f={["12px"]}>
                  Period
                </Text>
                <Text>{data.periode}</Text>
              </Box>
            </Flex>
          </Paper>
        </Box>
        <Paper zDepth={1} rounded={false}>
          <Flex w={[1]} p={[2]}>
            <Box w={[1]}>
              <Text py={[1]} f={["12px"]}>
                KTP
              </Text>
              <Text>{data.id_number}</Text>
              <Image src={data.ktp_picture} alt="image one" />
            </Box>
          </Flex>
        </Paper>
      </Box>
    );
  }
}

const LinkText = Text.extend`
  color: ${cyan500};
  text-decoration: none;
`;

const Image = styled.img`
  opacity: 1;
  display: block;
  height: auto;
  padding: 16;
  transition: 0.5s ease;
  backface-visibility: hidden;
`;

ActivationDetail.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  record: PropTypes.object,
  resource: PropTypes.string,
  style: PropTypes.object
};

export default ActivationDetail;



// WEBPACK FOOTER //
// ./src/activations/Detail.js